const colors = [
    '#F29CBF',
    '#7E85B9',
    '#42A2CE',
    '#79C28E',
    '#FFF165',
    '#ACA39F',
    '#F08589',
    '#F29CBF',
    '#BFC2DD',
    '#AA81B9',
    '#F9D1E3',
    '#FDF6B6',
    '#908DC4',
    '#E6C379'
];

const colorNames = {
    'brązowy': '#ACA39F',
    'czerwony': '#F08589',
    'niebieski': '#42A2CE',
    'szary': '#BFC2DD',
    'zielony': '#79C28E',
    'żółty': '#FFF165',
}

const extendedColors = [
    '#F29CBF',
    '#7E85B9',
    '#42A2CE',
    '#79C28E',
    '#FFF165',
    '#ACA39F',
    '#F08589',
    '#F29CBF',
    '#BFC2DD',
    '#AA81B9',
    '#F9D1E3',
    '#FDF6B6',
    '#908DC4',
    '#E6C379',
    '#F29CBF',
    '#7E85B9',
    '#42A2CE',
    '#79C28E',
    '#FFF165',
    '#ACA39F',
    '#F08589',
    '#F29CBF',
    '#BFC2DD',
    '#AA81B9',
    '#F9D1E3',
    '#FDF6B6',
    '#908DC4',
    '#E6C379',
    '#F29CBF',
    '#7E85B9',
    '#42A2CE',
    '#79C28E',
    '#FFF165',
    '#ACA39F',
    '#F08589',
    '#F29CBF',
    '#BFC2DD',
    '#AA81B9',
    '#F9D1E3',
    '#FDF6B6',
    '#908DC4',
]

const organizationColors = [
    'Czeladź',
    'Wojkowice',
    'Będzin',
    'Bobrowniki',
    'Mierzęcice',
    'Psary',
    'Siewierz',
    'Knurów',
    'Sławków',
    'Pyskowice',
    'Gierałtowice',
    'Pilchowice',
    'Rudziniec',
    'Sośnicowice',
    'Łaziska Górne',
    'Mikołów',
    'Wyry',
    'Kobiór',
    'Radzionków',
    'Tarnowskie Góry',
    'Ożarowice',
    'Świerklaniec',
    'Zbrosławice',
    'Bieruń',
    'Imielin',
    'Lędziny',
    'Bojszowy',
    'Chełm Śląski',
    'Bytom',
    'Chorzów',
    'Dąbrowa Górnicza',
    'Gliwice',
    'Katowice',
    'Mysłowice',
    'Piekary Śląskie',
    'Ruda Śląska',
    'Siemianowice Śląskie',
    'Sosnowiec',
    'Świętochłowice',
    'Zabrze',
    'Tychy'
].reduce((all: Array<any>, name: string, i) => {
    // @ts-ignore
    all[name]= extendedColors[i];
    return all;
}, {} as Array<any>);

export {
    colors,
    colorNames,
    organizationColors
}
